import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Icon width/height ratio — must match the viewBox below, or the mark gets
 * letterboxed inside the wrapper and renders smaller than `size`.
 */
const ratio = 89.12 / 86.23;

const Wrapper = styled.div`
  height: ${({ size }) => `${size}px`};
  width: ${({ size }) => `${size * ratio}px`};
`;

function BrandMark({ className, size = 22 }) {
  return (
    <Wrapper className={className} size={size}>
      <svg
        viewBox="0 0 89.12 86.23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.7556 2.04824C39.1566 -2.2449 63.3099 -0.454727 70.0632 13.8441C73.2017 21.8214 65.9353 28.3382 61.3825 34.0043C56.8334 39.9964 60.8413 46.7892 65.3835 42.059C70.0922 37.2341 79.1637 23.1889 85.8191 26.2875C87.8455 27.2311 88.8954 29.5218 89.07 31.7504C89.4597 36.7246 87.4397 43.4304 85.7624 48.6215C81.39 61.0048 74.6241 72.7841 64.1999 80.9135C55.7915 87.8215 41.8784 89.5547 38.7985 76.5297C37.7133 71.6417 38.8265 66.8126 39.8552 61.9535C40.7651 58.1426 42.8816 50.781 40.6052 50.1049C33.7146 47.349 30.0447 71.4526 28.198 74.1166C21.8485 87.4264 7.07707 89.114 1.21457 74.5424C-3.54187 61.0835 6.43555 47.7746 17.8786 41.4213C22.0885 38.9346 26.6321 37.0958 31.1648 35.268C35.4541 33.2956 44.0366 30.7805 44.405 26.9916C44.6875 23.1192 36.8967 25.8975 34.4255 26.8822C29.7143 28.7331 25.2391 31.0441 20.2058 32.2992C7.18868 36.1359 -1.40671 26.3899 6.49679 14.766C11.0424 8.45852 18.1255 4.27884 25.7556 2.04824Z"
          fill="#a875f0"
        />
      </svg>
    </Wrapper>
  );
}

BrandMark.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
};

export default styled(BrandMark)``;
